<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="名称或编号">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_testItem" @onRefresh="getTableData()">
        <el-button v-auth="'testItem:edit'" type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="itemName" label="检测项目" min-width="180" header-align="center" fixed></el-table-column>
        <el-table-column prop="itemCode" label="检测项目编号" width="200" align="center"></el-table-column>
        <el-table-column prop="createtime" label="创建时间" width="160" align="center"></el-table-column>

        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link v-auth="'testItem:edit'" type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link v-auth="'testItem:delete'" type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <TestItemEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <TestItemDetail :visible.sync="detailVisible" :activeId="activeRowId" />
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import TestItemEdit from './components/TestItemEdit';
import TestItemDetail from './components/TestItemDetail';

import { getItemList, deleteItem } from '@/api/system';

export default {
  components: { TableHeader, TestItemEdit, TestItemDetail },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        keyword: '',
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      tableSelection: [],
      // 弹窗
      activeRowId: null,
      detailVisible: false,
      editVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getItemList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteItem({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped></style>
